<template>
  <div class="content-foreignism-paragraphs-content" id="identidade-verbal-conteudo-estrangeirismos" data-search-anchor>
    <div class="content-foreignism-wrapper">
      <h1 class="content-foreignism-title">{{ contentForeignismTitle }}</h1>
    </div>
    <div class="content-foreignism-paragraphs-icon-wrapper">
      <div class="content-foreignism-icon-wrapper">
        <div class="content-foreignism-icon-wrapper-sec">
          <IconCheck />
          <div>
            <p class="content-foreignism-description-icon" v-html="contentForeignismDescription"></p>
          </div>
        </div>
      </div>

      <div class="content-foreignism-icon-wrapper">
        <div class="content-foreignism-icon-wrapper-sec">
          <IconCheck />
          <div>
            <p class="content-foreignism-description-icon" :style="{ whiteSpace: 'pre' }" v-html="contentForeignismDescription1"></p>
          </div>
        </div>
        <p class="content-foreignism-description">{{ contentForeignismDescription2 }}</p>
      </div>

      <div class="content-foreignism-icon-wrapper">
        <div class="content-foreignism-icon-wrapper-sec">
          <IconCheck />
          <div>
            <p class="content-foreignism-description-icon" v-html="contentForeignismDescription3"></p>
          </div>
        </div>
        <p class="content-foreignism-description">{{ contentForeignismDescription4 }}</p>
      </div>
      <div class="content-foreignism-icon-wrapper">
        <div class="content-foreignism-icon-wrapper-sec">
          <IconCheck />
          <div>
            <p class="content-foreignism-description-icon" v-html="contentForeignismDescription5"></p>
          </div>
        </div>
        <p class="content-foreignism-description">{{ contentForeignismDescription6 }}</p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import IconCheck from '@/assets/icons/IconCheck.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import ContentPageMixin from '@/mixins/content-page-mixin'
import { ContentPageStore } from '@/store/verbal-identity-page/content-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCheck } })
export default class ContentForeignismSection extends Mixins(ContentPageMixin) {
  contentPageStore: PageStoreContract = getModule(ContentPageStore, this.$store)

  get contentForeignismTitle(): string {
    return this.getElementText(3, 0)
  }

  get contentForeignismDescription(): string {
    const raw = this.getElementText(3, 1) || ''
    let texto = raw.normalize('NFC')
    const alvos = ['feminino', 'plural', 'somos'].map((a) => a.normalize('NFC'))
    const regex = new RegExp(`(${alvos.join('|')})`, 'gi')
    texto = texto.replace(regex, (match) => {
      return `<strong class="bold-highlight">${match}</strong>`
    })

    return texto
  }

  get contentForeignismDescription1(): string {
    const raw = this.getElementText(3, 2) || ''
    let texto = raw.normalize('NFC')
    const alvos = ['uma', 'coletividade'].map((a) => a.normalize('NFC'))
    const regex = new RegExp(`(${alvos.join('|')})`, 'gi')
    texto = texto.replace(regex, (match) => {
      return `<strong class="bold-highlight">${match}</strong>`
    })

    return texto
  }

  get contentForeignismDescription2(): string {
    return this.getElementText(3, 3)
  }

  get contentForeignismDescription3(): string {
    const raw = this.getElementText(3, 4) || ''    
    const texto = raw.replace(/\s+/g, ' ').trim()
    const alvo = 'traduzir ou adaptar termos do inglês para o português'    
    const regex = new RegExp(alvo.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i')
    const partes = texto.split(regex)    
 
    if (partes.length < 2) {
      return texto
    }
    return partes[0] + `<strong class="bold-highlight">${alvo}</strong>` + partes.slice(1).join(alvo)
  }

  get contentForeignismDescription4(): string {
    return this.getElementText(3, 5)
  }

  get contentForeignismDescription5(): string {
    const raw = this.getElementText(3, 6) || ''
    let texto = raw.normalize('NFC')
    const alvos = ['presente', 'plural'].map((a) => a.normalize('NFC'))
    const regex = new RegExp(`(${alvos.join('|')})`, 'gi')
    texto = texto.replace(regex, (match) => {
      return `<strong class="bold-highlight">${match}</strong>`
    })

    return texto
  }

  get contentForeignismDescription6(): string {
    return this.getElementText(3, 7)
  }
  async getContentPage(): Promise<void> {
    await this.contentPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.contentPageStore.isLoading) {
      await this.getContentPage()
    }
  }
}
</script>

<style lang="scss">
.content-foreignism-paragraphs-content {
  display: grid;
  width: 1032px;
}

.content-foreignism-wrapper {
  display: flex;
  align-items: flex-start;
  padding-top: 85px;
  padding-bottom: 50px;
}

.content-foreignism-title {
  font-size: 56px;
  font-weight: 400;
  line-height: 60px;
  letter-spacing: -0.01em;
  text-align: left;
  margin-bottom: 0px;
  padding-right: 50px;
}

.content-foreignism-title .bold-highlight {
  font-weight: 700 !important;
  font-family: InterVariableBold;
}

.content-foreignism-paragraphs-icon-wrapper {
  position: relative;
  display: grid;
  grid-template-columns: 56% 44%;
  margin-bottom: 50px;
}

.content-foreignism-icon-wrapper-sec {
  display: flex;
}

.content-foreignism-description {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  margin-bottom: 32px;
  padding-left: 44px;
  width: 430px;
  margin-top: 0;
  white-space: pre-line;
}

.content-foreignism-description-icon {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  margin-top: 0;
  padding-left: 7px;
  width: 404px;
  
}

.content-foreignism-description-icon .bold-highlight {
  font-weight: 700 !important;
  font-family: InterVariableBold;
}
</style>
